var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-component",class:{ fixed: _vm.fixed, absolute: _vm.absolute }},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }